import React from 'react';
import TabPanel from '../../../../../../../components/ResourceAssignment/TabPanel';
import { GLOBAL_DEDUCTIONS_RESOURCE, GLOBAL_DEDUCTIONS_TABS } from '../Model/Models';
import { AddGlobalDeductionsApp } from '../Functionality/AddGlobalDeductionsApp';
import { AssignedGlobalDeductionsApp } from '../Functionality/AssignedGlobalDeductionsApp';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Step 3 of the Create User Deduction Policy stepper.
 * Lists all global deduction rules and allows selecting which ones to exclude.
 */
const StepGlobalRules = ({
    id,
    excludedGlobalRules,
    setExcludedGlobalRules,
    selectForDelete,
    setSelectForDelete,
    searchElement,
    setSearchElement,
    modified,
    setModified,
    disabled
}) => {

    return (
        <TabPanel
            resource={GLOBAL_DEDUCTIONS_RESOURCE}
            tabsConfig={GLOBAL_DEDUCTIONS_TABS}
            selected={excludedGlobalRules}
            setSelected={setExcludedGlobalRules}
            selectForDelete={selectForDelete}
            setSelectForDelete={setSelectForDelete}
            searchElement={searchElement}
            setSearchElement={setSearchElement}
            modified={modified}
            setModified={setModified}
            id={id}
            deleteButtonId="btn_sgr_delete"
            useAddApp={AddGlobalDeductionsApp}
            useAssignedApp={AssignedGlobalDeductionsApp}
            disabled={disabled}
        />
    );
};

export default StepGlobalRules;
